/* istanbul ignore file */
import $ from 'jquery';

/**
 * @example
 *     import {jwplayer8Script} from 'stl-common/src/jwplayer.js';
 *     jwplayer8Script.fetch().then((player) => player.setup());
 */
export default class JWPlayerScript {
    constructor({rev, src, key}) {
        this.rev = rev;
        this.src = src;
        this.key = key;
    }

    fetch() {
        return $.ajax({
            url: this.src,
            dataType: 'script',
            cache: true,
            success: () => {
                window.jwplayer.key = this.key;
                return window.jwplayer;
            },
        });
    }
}

// Sinclair's Custom Build and License Key for JWPlayer 8.
export const jwplayer8Script = new JWPlayerScript({
    rev: 8,
    src: '/resources/video/players/prod/src/vendor/jwplayer/8.3.3/jwplayer.js',
    key: 'NmyR5FEcgylCwcHIf4A24vt9zEpByvHNyPgYVw==',
});
